import { Action, FrameStencils, Marker, MarkerBall, MarkerType, StencilType } from "../types";

export interface GetPlayerBallStencilProps {
  stencil: Marker | Action;
  frameStencils: FrameStencils;
}

export const getPlayerBallStencil = ({ stencil, frameStencils }: GetPlayerBallStencilProps): MarkerBall | null => {
  const { stencilType } = stencil;

  if (stencilType === StencilType.MARKER) {
    const { markerType } = stencil;
    if (markerType === MarkerType.PLAYER) {
      if (stencil.possession) {
        const ballStencil = frameStencils.find(
          (frameStencil): frameStencil is MarkerBall =>
            frameStencil.stencilType === StencilType.MARKER &&
            frameStencil.markerType === MarkerType.BALL &&
            frameStencil.associatedPlayer === stencil.id
        );
        return ballStencil || null;
      } else return null;
    } else return null;
  } else return null;
};
